var n = Object.defineProperty;
var o = (s, t, e) => t in s ? n(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var i = (s, t, e) => o(s, typeof t != "symbol" ? t + "" : t, e);
import { s as c, H as u, r as P, V as p, F as d, P as h, t as l, u as f, v as V, w as y, o as I } from "./vidstack-CW95SyGp.js";
import { H as v } from "./vidstack-html-BSHnIZtr.js";
class m extends v {
  constructor(e, r) {
    super(e, r);
    i(this, "$$PROVIDER_TYPE", "VIDEO");
    i(this, "airPlay");
    i(this, "fullscreen");
    i(this, "pictureInPicture");
    c(() => {
      if (this.airPlay = new u(e, r), P(e)) {
        const a = new p(e, r);
        this.fullscreen = new d(a), this.pictureInPicture = new h(a);
      } else l(e) && (this.pictureInPicture = new f(e, r));
    }, this.scope);
  }
  get type() {
    return "video";
  }
  setup() {
    super.setup(), V(this.video) && new y(this.video, this.ctx), this.ctx.textRenderers.attachVideo(this.video), I(() => {
      this.ctx.textRenderers.attachVideo(null);
    }), this.type === "video" && this.ctx.notify("provider-setup", this);
  }
  /**
   * The native HTML `<video>` element.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLVideoElement}
   */
  get video() {
    return this.media;
  }
}
export {
  m as VideoProvider
};
